export { default } from './StatsGraphAlternate'
